import { ChakraProvider } from '@chakra-ui/react';

import { Calendar, EventDetailModal } from './components/calendar';
import {
	CalendarSettingsProvider,
	FiltersProvider,
	ModalProvider,
	CalendarViewProvider,
	EventPositionProvider,
} from '../src/lib';
import { theme } from './theme';

import './style.scss';

const CalendarPlus: React.FunctionComponent = () => {
	return (
		<ChakraProvider theme={theme}>
			<CalendarSettingsProvider>
				<FiltersProvider>
					<CalendarViewProvider>
						<ModalProvider>
							<EventPositionProvider>
								<Calendar />
								<EventDetailModal />
							</EventPositionProvider>
						</ModalProvider>
					</CalendarViewProvider>
				</FiltersProvider>
			</CalendarSettingsProvider>
		</ChakraProvider>
	);
};

export default CalendarPlus;
